import { useState, useEffect } from 'react';
import { useTripInfo } from "../context";

import styles from './weatherPage.module.css';
import { dayOnly, dayOfMonth } from '../utils/dateConverter';
import { weatherPageInfo } from '../utils/fatch';
import { NoWeather } from './noWeather';

import { getWeatherIcon } from '../utils/weatherIcons';
export function WeatherPage() {
    const { weatherActive } = useTripInfo();
    const [weatherData, setWeatherData] = useState([]);
    const [currentWeather, setCurrentWeather] = useState([]);


    const [city, setCity] = useState('');
    const [state, setState] = useState('');
    const [destinationForWeather, setDestinationForWeather] = useState(true);



    const EachBox = (props) => {

        const dayProbability = props.day.daytimeForecast.precipitation.probability;
        const nightProbability = props.day.nighttimeForecast.precipitation.probability;
        const dayWind = props.day.daytimeForecast.wind.speed.value;
        const nightWind = props.day.nighttimeForecast.wind.speed.value;

        const dayHumidity = props.day.daytimeForecast.relativeHumidity;
        const nightHumidity = props.day.nighttimeForecast.relativeHumidity;

        //day.daytimeForecast.

        const dayType = props.day.daytimeForecast.weatherCondition.description.text;
        const nightType = props.day.nighttimeForecast.weatherCondition.description.text;

        const max = props.day.maxTemperature.degrees;
        const min = props.day.minTemperature.degrees;

        const dayOfWeek = new Date(props.day.interval.startTime).toLocaleDateString("en-US", dayOnly);
        const monthAndDayOfMonth = new Date(props.day.interval.startTime).toLocaleDateString("en-US", dayOfMonth);


        //const dayIcon = props.day.daytimeForecast.weatherCondition.iconBaseUri;
        //const nightIcon = props.day.nighttimeForecast.weatherCondition.iconBaseUri;

        const typeForDay = props.day.daytimeForecast.weatherCondition.type;
        const dayIcon = getWeatherIcon(typeForDay, 'day');
        const typeForNight = props.day.nighttimeForecast.weatherCondition.type;
        const nightIcon = getWeatherIcon(typeForNight, 'night');

      


        return (<>




            <div className={`${styles.forEach2}  rounded-lg shadow-[0_0_4px_rgba(0,0,0,0.1)]`} >
                <div className={styles.header2}>

                    <p className="font-bold text-lg">{props.index === 0 ? 'Today' : dayOfWeek}</p>
                    <p className="text-sm" style={{ color: "#6fa9cc" }}>{monthAndDayOfMonth}</p>
                    <div className={styles.maxMinCon2}>
                        <p className="text-xl font-bold">

                            {props.fahrenheit ? props.celsiusToFahrenheit(max) : max}
                            ° / {' '}
                            {props.fahrenheit ? props.celsiusToFahrenheit(min) : min}
                            °


                        </p>

                    </div>


                </div>




                <div>

                    <div className={styles.space}></div>
                    {/* morning */}
                    <div className={styles.morning}>
                        <div className={styles.pAndImg}>
                            <p style={{ width: '100px' }}>Morning</p>


                            <img src={dayIcon} alt={typeForDay + 'icon'} />
                            {/*   <img src={dayIcon + '.png'} alt={`${dayType} icon`} /> */}

                            <p style={{ width: '100px', color: "#6fa9cc", textAlign: 'end' }} className="text-sm">
                                {dayType}</p>


                        </div>








                        <div
                            className={styles.iconsCon2}>

                            {(dayProbability.type === 'RAIN' || dayProbability.type === 'SNOW' || dayProbability.type === 'RAIN_AND_SNOW') &&

                                <span className="flex items-center gap-1">
                                    {dayProbability.type === 'RAIN' &&
                                        <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#6fa9cc"><path d="M491-200q12-1 20.5-9.5T520-230q0-14-9-22.5t-23-7.5q-41 3-87-22.5T343-375q-2-11-10.5-18t-19.5-7q-14 0-23 10.5t-6 24.5q17 91 80 130t127 35ZM480-80q-137 0-228.5-94T160-408q0-100 79.5-217.5T480-880q161 137 240.5 254.5T800-408q0 140-91.5 234T480-80Zm0-80q104 0 172-70.5T720-408q0-73-60.5-165T480-774Q361-665 300.5-573T240-408q0 107 68 177.5T480-160Zm0-320Z" /></svg>
                                    } {dayProbability.type === 'SNOW' &&
                                        <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#6fa9cc"><path d="M440-80v-166L310-118l-56-56 186-186v-80h-80L174-254l-56-56 128-130H80v-80h166L118-650l56-56 186 186h80v-80L254-786l56-56 130 128v-166h80v166l130-128 56 56-186 186v80h80l186-186 56 56-128 130h166v80H714l128 130-56 56-186-186h-80v80l186 186-56 56-130-128v166h-80Z" /></svg>
                                    } {dayProbability.type === 'RAIN_AND_SNOW' &&
                                        <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#6fa9cc"><path d="M338-204q-15 8-30.5 2.5T284-222l-60-120q-8-15-2.5-30.5T242-396q15-8 30.5-2.5T296-378l60 120q8 15 2.5 30.5T338-204Zm360 0q-15 8-30.5 2.5T644-222L464-582q-8-15-2.5-30.5T482-636q15-8 30.5-2.5T536-618l180 360q8 15 2.5 30.5T698-204Zm-188 4q-17 0-28.5-11.5T470-240q0-17 11.5-28.5T510-280q17 0 28.5 11.5T550-240q0 17-11.5 28.5T510-200Zm388-4q-15 8-30.5 2.5T844-222l-20-40q-8-15-2.5-30.5T842-316q15-8 30.5-2.5T896-298l20 40q8 15 2.5 30.5T898-204ZM458-324q-15 8-30.5 2.5T404-342L224-702q-8-15-2.5-30.5T242-756q15-8 30.5-2.5T296-738l180 360q8 15 2.5 30.5T458-324Zm342-36q-17 0-28.5-11.5T760-400q0-17 11.5-28.5T800-440q17 0 28.5 11.5T840-400q0 17-11.5 28.5T800-360Zm-600-80q-17 0-28.5-11.5T160-480q0-17 11.5-28.5T200-520q17 0 28.5 11.5T240-480q0 17-11.5 28.5T200-440Zm558-44q-15 8-30.5 2.5T704-502L604-702q-8-15-2.5-30.5T622-756q15-8 30.5-2.5T676-738l100 200q8 15 2.5 30.5T758-484Zm-600-80q-15 8-30.5 2.5T104-582L44-702q-8-15-2.5-30.5T62-756q15-8 30.5-2.5T116-738l60 120q8 15 2.5 30.5T158-564Zm292-116q-17 0-28.5-11.5T410-720q0-17 11.5-28.5T450-760q17 0 28.5 11.5T490-720q0 17-11.5 28.5T450-680Z" /></svg>
                                    }

                                    {dayProbability.percent}%
                                </span>

                            }


                            <span className="flex items-center gap-1">
                                <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#6fa9cc"><path d="M460-160q-50 0-85-35t-35-85h80q0 17 11.5 28.5T460-240q17 0 28.5-11.5T500-280q0-17-11.5-28.5T460-320H80v-80h380q50 0 85 35t35 85q0 50-35 85t-85 35ZM80-560v-80h540q26 0 43-17t17-43q0-26-17-43t-43-17q-26 0-43 17t-17 43h-80q0-59 40.5-99.5T620-840q59 0 99.5 40.5T760-700q0 59-40.5 99.5T620-560H80Zm660 320v-80q26 0 43-17t17-43q0-26-17-43t-43-17H80v-80h660q59 0 99.5 40.5T880-380q0 59-40.5 99.5T740-240Z" /></svg>
                                {dayWind + ' '}km/h</span>
                            <span className="flex items-center gap-1">
                                <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#6fa9cc"><path d="M520-520v-80h200v80H520Zm0-160v-80h320v80H520ZM320-120q-83 0-141.5-58.5T120-320q0-48 21-89.5t59-70.5v-240q0-50 35-85t85-35q50 0 85 35t35 85v240q38 29 59 70.5t21 89.5q0 83-58.5 141.5T320-120ZM200-320h240q0-29-12.5-54T392-416l-32-24v-280q0-17-11.5-28.5T320-760q-17 0-28.5 11.5T280-720v280l-32 24q-23 17-35.5 42T200-320Z" /></svg>
                                {dayHumidity}%</span>
                        </div>

                    </div>
                    <div className={styles.space}></div>
                    {/* night */}
                    <div className={styles.night}>

                        <div className={styles.pAndImg}>
                            <p style={{ width: '100px' }}>Night</p>


                            <img src={nightIcon} alt={typeForNight + 'icon'} />
                            {/*  <img src={nightIcon + '.png'} alt={`${nightType} icon`} /> */}
                            <p style={{ width: '100px', color: "#6fa9cc", textAlign: 'end' }} className="text-sm">
                                {nightType} </p>



                        </div>





                        <div
                            className={styles.iconsCon2}>

                            {(nightProbability.type === 'RAIN' || nightProbability.type === 'SNOW' || nightProbability.type === 'RAIN_AND_SNOW') &&
                                <span className="flex items-center gap-1">
                                    {nightProbability.type === 'RAIN' &&
                                        <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#6fa9cc"><path d="M491-200q12-1 20.5-9.5T520-230q0-14-9-22.5t-23-7.5q-41 3-87-22.5T343-375q-2-11-10.5-18t-19.5-7q-14 0-23 10.5t-6 24.5q17 91 80 130t127 35ZM480-80q-137 0-228.5-94T160-408q0-100 79.5-217.5T480-880q161 137 240.5 254.5T800-408q0 140-91.5 234T480-80Zm0-80q104 0 172-70.5T720-408q0-73-60.5-165T480-774Q361-665 300.5-573T240-408q0 107 68 177.5T480-160Zm0-320Z" /></svg>
                                    } {nightProbability.type === 'SNOW' &&
                                        <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#6fa9cc"><path d="M440-80v-166L310-118l-56-56 186-186v-80h-80L174-254l-56-56 128-130H80v-80h166L118-650l56-56 186 186h80v-80L254-786l56-56 130 128v-166h80v166l130-128 56 56-186 186v80h80l186-186 56 56-128 130h166v80H714l128 130-56 56-186-186h-80v80l186 186-56 56-130-128v166h-80Z" /></svg>
                                    } {nightProbability.type === 'RAIN_AND_SNOW' &&
                                        <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#6fa9cc"><path d="M338-204q-15 8-30.5 2.5T284-222l-60-120q-8-15-2.5-30.5T242-396q15-8 30.5-2.5T296-378l60 120q8 15 2.5 30.5T338-204Zm360 0q-15 8-30.5 2.5T644-222L464-582q-8-15-2.5-30.5T482-636q15-8 30.5-2.5T536-618l180 360q8 15 2.5 30.5T698-204Zm-188 4q-17 0-28.5-11.5T470-240q0-17 11.5-28.5T510-280q17 0 28.5 11.5T550-240q0 17-11.5 28.5T510-200Zm388-4q-15 8-30.5 2.5T844-222l-20-40q-8-15-2.5-30.5T842-316q15-8 30.5-2.5T896-298l20 40q8 15 2.5 30.5T898-204ZM458-324q-15 8-30.5 2.5T404-342L224-702q-8-15-2.5-30.5T242-756q15-8 30.5-2.5T296-738l180 360q8 15 2.5 30.5T458-324Zm342-36q-17 0-28.5-11.5T760-400q0-17 11.5-28.5T800-440q17 0 28.5 11.5T840-400q0 17-11.5 28.5T800-360Zm-600-80q-17 0-28.5-11.5T160-480q0-17 11.5-28.5T200-520q17 0 28.5 11.5T240-480q0 17-11.5 28.5T200-440Zm558-44q-15 8-30.5 2.5T704-502L604-702q-8-15-2.5-30.5T622-756q15-8 30.5-2.5T676-738l100 200q8 15 2.5 30.5T758-484Zm-600-80q-15 8-30.5 2.5T104-582L44-702q-8-15-2.5-30.5T62-756q15-8 30.5-2.5T116-738l60 120q8 15 2.5 30.5T158-564Zm292-116q-17 0-28.5-11.5T410-720q0-17 11.5-28.5T450-760q17 0 28.5 11.5T490-720q0 17-11.5 28.5T450-680Z" /></svg>
                                    }

                                    {nightProbability.percent}%
                                </span>

                            }
                            <span className="flex items-center gap-1">
                                <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#6fa9cc"><path d="M460-160q-50 0-85-35t-35-85h80q0 17 11.5 28.5T460-240q17 0 28.5-11.5T500-280q0-17-11.5-28.5T460-320H80v-80h380q50 0 85 35t35 85q0 50-35 85t-85 35ZM80-560v-80h540q26 0 43-17t17-43q0-26-17-43t-43-17q-26 0-43 17t-17 43h-80q0-59 40.5-99.5T620-840q59 0 99.5 40.5T760-700q0 59-40.5 99.5T620-560H80Zm660 320v-80q26 0 43-17t17-43q0-26-17-43t-43-17H80v-80h660q59 0 99.5 40.5T880-380q0 59-40.5 99.5T740-240Z" /></svg>
                                {nightWind + ' '} km/h</span>
                            <span className="flex items-center gap-1">
                                <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#6fa9cc"><path d="M520-520v-80h200v80H520Zm0-160v-80h320v80H520ZM320-120q-83 0-141.5-58.5T120-320q0-48 21-89.5t59-70.5v-240q0-50 35-85t85-35q50 0 85 35t35 85v240q38 29 59 70.5t21 89.5q0 83-58.5 141.5T320-120ZM200-320h240q0-29-12.5-54T392-416l-32-24v-280q0-17-11.5-28.5T320-760q-17 0-28.5 11.5T280-720v280l-32 24q-23 17-35.5 42T200-320Z" /></svg>
                                {nightHumidity}%</span>
                        </div>

                    </div>

                </div>






            </div>







        </>

        )
    }

    const defaultImg = 'https://lh3.googleusercontent.com/aida-public/AB6AXuC51V9qQezLL8zwZJcCvBnz_3BuE8JzSGxdYqmtdv7K1dAdvjal4QJqVvg7FlL3E1Eb38r7KpmecVKJAq-sWhpfN0IrLu4XjA_H8khyI0spk6ucw21fa1PY2SUNhcIVr8l_66Qfk_Hmt43UgBF2pZvor_k1yq4z-tpnNIrojX2FkiG9m9pFKawtH-lXLUSs4UkFUiWTKU4X9mfNXCXS9pHtw7JjdYt-o7NL4MwkrI5G_mRJDsJHe7Himrw1W-OO7gpuctiSO5JAMuI';
    const [image, setImage] = useState(defaultImg);
    //const [tripId, setTripId] = useState




    useEffect(() => {

        const getData = async () => {
            try {



                const result = await weatherPageInfo();
                if (result.status === 200) {
                    const {
                        data = null,
                        img = '/default.jpg',
                        state = 'unknown',
                        city = 'unknown',
                        currentWeatherData = {}
                    } = result || {};

                    if (data) {
                        if (img) {
                            setImage(img);
                        }
                        if (city) {

                            setCity(city);
                        }
                        if (state) {
                            setState(state)
                        }

                   

                        setWeatherData(data);


                        setCurrentWeather([currentWeatherData]);
                    }
                }
                else if (result.status === 400) {
                    setDestinationForWeather(false);
                }




            } catch (error) {
                console.error(error);

            }

        }



        if (weatherActive.active) {

            getData();
        }
    }, [weatherActive])




    const [fahrenheit, setFahrenheit] = useState(true);
    function celsiusToFahrenheit(celsius) {
        return Math.round((celsius * 9 / 5) + 32);

    }

    return (<>


        {weatherActive.active ?
            destinationForWeather ?
                <div className={styles.backgroundImg}>

                    <div className={styles.main}>
                        <div className="relative flex min-h-screen w-full flex-col group/design-root overflow-x-hidden">
                            <div className="layout-container flex h-full grow flex-col">
                                <div className=" flex flex-1 justify-center">
                                    <div className="layout-content-container flex flex-col max-w-[960px] flex-1">

                                        <main className={`${styles.mainCon} flex flex-col gap-6 p-4`}>




                                            <div className="flex flex-wrap justify-between items-center gap-3">
                                                <div className='font-bold' style={{ display: 'flex', flexDirection: 'row', alignItems: "center" }}>
                                                    <svg className='mr-4' xmlns="http://www.w3.org/2000/svg" height="36px" viewBox="0 -960 960 960" width="36px" fill="#FFFFFF"><path d="M480-80q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q152 0 263.5 98T876-538q-20-10-41.5-15.5T790-560q-19-73-68.5-130T600-776v16q0 33-23.5 56.5T520-680h-80v80q0 17-11.5 28.5T400-560h-80v80h240q11 0 20.5 5.5T595-459q-17 27-26 57t-9 62q0 63 32.5 117T659-122q-41 20-86 31t-93 11Zm-40-82v-78q-33 0-56.5-23.5T360-320v-40L168-552q-3 18-5.5 36t-2.5 36q0 121 79.5 212T440-162Zm340 82q-7 0-12-4t-7-10q-11-35-31-65t-43-59q-21-26-34-57t-13-65q0-58 41-99t99-41q58 0 99 41t41 99q0 34-13.5 64.5T873-218q-23 29-43 59t-31 65q-2 6-7 10t-12 4Zm0-113q10-17 22-31.5t23-29.5q14-19 24.5-40.5T860-340q0-33-23.5-56.5T780-420q-33 0-56.5 23.5T700-340q0 24 10.5 45.5T735-254q12 15 23.5 29.5T780-193Zm0-97q-21 0-35.5-14.5T730-340q0-21 14.5-35.5T780-390q21 0 35.5 14.5T830-340q0 21-14.5 35.5T780-290Z" /></svg>

                                                    <p className="text-3xl  leading-tight tracking-[-0.033em]" style={{ color: "#fdfefeff" }}>
                                                        {city && city}, {state && state}</p>

                                                </div>
                                                <div className={styles.segmentedControl}>
                                                    <div className={styles.slider} style={{ left: fahrenheit ? '50%' : '0%' }} />
                                                    <div className={`${styles.segmentedControlOption} ${!fahrenheit ? styles.active : ''}`} onClick={() => setFahrenheit(false)}>C</div>
                                                    <div className={`${styles.segmentedControlOption} ${fahrenheit ? styles.active : ''}`} onClick={() => setFahrenheit(true)}>F</div>
                                                </div>


                                            </div>

                                            <div
                                                className="flex flex-col md:flex-row items-stretch justify-between gap-4 rounded-lg p-6 shadow-[0_0_4px_rgba(0,0,0,0.1)]" style={{ backgroundColor: '#ffffff' }}>
                                                <div className="flex flex-col gap-2 flex-[2_2_0px]">
                                                    <p
                                                        className=" text-sm font-normal leading-normal" style={{ color: "#6fa9cc" }}>
                                                        Now</p>
                                                    {currentWeather.length && <>
                                                      
                                                        <p className="text-4xl font-bold leading-tight">{currentWeather[0].weatherCondition.description.text}</p>


                                                        <p className="text-4xl font-black tracking-tighter text-primary">

                                                            {fahrenheit ?
                                                                celsiusToFahrenheit(currentWeather[0].temperature.degrees)
                                                                :
                                                                currentWeather[0].temperature.degrees}°
                                                        </p>





                                                  

                                                        <p className="text-md font-black  text-primary">Feels Like:
                                                            <span className="text-xl tracking-tighter">{' '}

                                                                {fahrenheit ? celsiusToFahrenheit(currentWeather[0].feelsLikeTemperature.degrees) :
                                                                    currentWeather[0].feelsLikeTemperature.degrees}°
                                                            </span> </p>
                                                    </>}

                                                </div>
                                                <div className="w-full bg-center bg-no-repeat aspect-video bg-cover rounded-lg flex-1"
                                                    data-alt="Stylized image of a partly cloudy sky"
                                                    style={{ backgroundImage: `url(${image})` }}>
                                                </div>
                                            </div>



                                            <h2 className="text-[22px] font-bold leading-tight tracking-[-0.015em] pt-5" style={{ color: "#fbfcfdff" }}>10-Day Forecast</h2>
                                            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            

                                                {weatherData.length > 0 && (weatherData.map((day, i) => (
                                                    <EachBox key={i} celsiusToFahrenheit={celsiusToFahrenheit} fahrenheit={fahrenheit} day={day} index={i} />

                                                )))}




                                            </div>
                                            <div className="mt-8 text-center text-xs" style={{ color: "#6fa9cc" }}>
                                                <p>Weather icons provided by <a href="https://www.amcharts.com/" target="_blank" > amcharts.com</a></p>
                                            </div>
                                        </main>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                :
                <NoWeather type='noLocation' />

            :

            weatherActive.endAlready ?
                <>
                    <NoWeather type='end' />
                   
                </>

                :
                <>
                    <NoWeather type='notActive' />
                                       



                </>


        }

    </>)
}



